import { useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useDimensions = (domNode: HTMLElement) => {
  const [dimensions, setDimensions] = useState<DOMRectReadOnly>();

  useEffect(() => {
    const resizeObserver = new ResizeObserver(([entry]) => setDimensions(entry.contentRect));
    if (domNode) {
      resizeObserver.observe(domNode);
      return () => resizeObserver.unobserve(domNode);
    }

    return undefined;
  }, [domNode]);

  return dimensions;
};
